<template>
  <div>
    <div v-if="application.preApproved" id="application-pre-approved">
      <div class="small">{{$t('LoanApplicationTimeline.youCanNowChoosePayoutMethod')}}</div>
      <button class="btn btn-sm btn-primary mt-3 mb-2 px-3">{{$t('LoanApplicationTimeline.choosePayoutMethod')}}</button>
    </div>
    <div v-else>
      <div class="small">{{payoutMethodDescription}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CollectCashStageComponent',
    props: ['application'],
    computed: {
      payoutMethodDescription() {
        if (this.$configuration.newCoreEnabled || this.application.productType === 'DEALER') {
          return ''
        }
        return this.$t(`LoanApplicationTimeline.payoutMethod.${this.application.payoutMethod}`)
      }
    }
  }
</script>
